import React from 'react';
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Stack, TextField,} from '@mui/material';

interface UcretModalProps {
    open: boolean;
    onClose: () => void;
    formik: any;
    activeRol: any;
}

const UcretModal: React.FC<UcretModalProps> = ({open, onClose, formik, activeRol}) => {
    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
            <form onSubmit={formik.handleSubmit}>
                <DialogTitle>Ücret Tanımla: {activeRol?.rolAdi}</DialogTitle>
                <DialogContent>
                    <TextField
                        fullWidth
                        label="Başlangıç (GG-AA-YYYY)"
                        name="baslangic_tarih"
                        placeholder="01-01-2024"
                        value={formik.values.baslangic_tarih}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.baslangic_tarih && Boolean(formik.errors.baslangic_tarih)}
                        helperText={formik.touched.baslangic_tarih && formik.errors.baslangic_tarih}
                        sx={{mt: 2}}
                    />
                    <TextField
                        fullWidth
                        label="Bitiş (GG-AA-YYYY)"
                        name="bitis_tarih"
                        placeholder="31-12-2099"
                        value={formik.values.bitis_tarih}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.bitis_tarih && Boolean(formik.errors.bitis_tarih)}
                        helperText={formik.touched.bitis_tarih && formik.errors.bitis_tarih}
                        sx={{mt: 2}}
                    />
                    <Divider sx={{my: 2}}>Ücretler</Divider>
                    <Stack direction="row" spacing={2}>
                        <TextField
                            fullWidth
                            type="number"
                            label="Saatlik"
                            name="saat"
                            value={formik.values.saat}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.touched.saat && Boolean(formik.errors.saat)}
                            helperText={formik.touched.saat && formik.errors.saat}
                        />
                        <TextField
                            fullWidth
                            type="number"
                            label="Günlük"
                            name="gun"
                            value={formik.values.gun}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.touched.gun && Boolean(formik.errors.gun)}
                            helperText={formik.touched.gun && formik.errors.gun}
                        />
                    </Stack>
                    <Stack direction="row" spacing={2} sx={{mt: 2}}>
                        <TextField
                            fullWidth
                            type="number"
                            label="Aylık"
                            name="ay"
                            value={formik.values.ay}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.touched.ay && Boolean(formik.errors.ay)}
                            helperText={formik.touched.ay && formik.errors.ay}
                        />
                        <TextField
                            fullWidth
                            type="number"
                            label="Ekstra"
                            name="ekstra"
                            value={formik.values.ekstra}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.touched.ekstra && Boolean(formik.errors.ekstra)}
                            helperText={formik.touched.ekstra && formik.errors.ekstra}
                        />
                    </Stack>
                </DialogContent>
                <DialogActions>
                    <Button onClick={onClose}>İptal</Button>
                    <Button color="primary" type="submit">
                        Kaydet
                    </Button>
                </DialogActions>
            </form>
        </Dialog>
    );
};

export default UcretModal;
